import http from "@/plugins/http";

export const state = {
  wholesalers: [],
  impersonating: null
};

export const getters = {
  wholesalers: state => {
    return state.wholesalers;
  },
  impersonating: state => {
    return state.impersonating;
  }
};

export const mutations = {
  SET_WHOLESALERS(state, data) {
    state.wholesalers = data;
  },
  SET_IMPERSONATING(state, data) {
    state.impersonating = data;
  }
};

export const actions = {
  async getWholesalers({ commit }) {
    let data = await http.get(`visp/GetWholesalers`);
    commit("SET_WHOLESALERS", data.data.data);
  },
  async setImpersonatingAs({ commit }, val) {
    let data = await http.post(`visp/updateImpersonate`, {
      id: 0,
      impersonateEmail: val.oneLoginEmail
    });
    commit("SET_IMPERSONATING", data.data);
  },
  async getImpersonating({ commit, dispatch }) {
    let response = await http.get(`visp/GetImpersonating`);
    if (response.status == 200) {
      commit("SET_IMPERSONATING", response.data.data);
      dispatch("auth/setRoles", response.data.groups, { root: true });
    }
  },
  async removeImpersonating({ commit, state }) {
    let data = await http.post(`visp/RemoveImpersonate`, {
      id: 0,
      impersonateEmail: state.impersonating.impersonateEmail
    });
    if (data.data.success) commit("SET_IMPERSONATING", null);
  }
};
